export const HOME = "/"
export const SIGN_UP = "/sign-up"
export const SIGN_IN = "/login"
export const PASSWORD_FORGET = "/pw-forget"
export const ACCOUNT = "/dashboard"
export const PROFILE = "/@{{id}}"
